export default __webpack_public_path__ + "static/media/roadMap-right-monkey.348d5e95.svg";